module.exports = __webpack_public_path__ + "static/media/chatFile.ede48b44.svg";